export default function SliderLanguage({ hook: spanish, setHook }) {
  const toggleLanguage = () => {
    setHook(!spanish);
  };

  return (
    <div
      onClick={toggleLanguage}
      style={{
        width: '180px',
        height: '40px',
        borderRadius: '20px',
        background: '#d3d3d3',
        cursor: 'pointer',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '5px 8px',
        boxSizing: 'border-box',
        userSelect: 'none',
        fontFamily: 'sans-serif',
        fontSize: '14px',
      }}
    >
      {/* Labels */}
      <div
        style={{
          flex: 1,
          textAlign: 'center',
          color: spanish ? '#888' : '#000',
          zIndex: 2,
        }}
      >
        English
      </div>
      <div
        style={{
          flex: 1,
          textAlign: 'center',
          color: spanish ? '#000' : '#888',
          zIndex: 2,
        }}
      >
        Español
      </div>

      {/* Slider knob */}
      <div
        style={{
          position: 'absolute',
          top: '3px',
          left: spanish ? '89px' : '3px',
          width: '88px',
          height: '34px',
          backgroundColor: '#f5f5f5',
          borderRadius: '17px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          transition: 'left 0.25s ease',
          zIndex: 1,
        }}
      />
    </div>
  );
}
